// src/contexts/DonationContext.js

import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
// [제거] import { getDonationHallOfFame } from '../services/api'; // Functions 호출 제거

const DonationContext = createContext();

export const useDonationContext = () => {
  const context = useContext(DonationContext);
  if (!context) {
    throw new Error('useDonationContext must be used within DonationProvider');
  }
  return context;
};

export const DonationProvider = ({ children, piUser }) => {
  // [추가] 명예의 전당 데이터 상태
  const [hallOfFameData, setHallOfFameData] = useState([]);
  const [isHallOfFameLoading, setIsHallOfFameLoading] = useState(false);
  const [hallOfFameError, setHallOfFameError] = useState(null);
  const [hallOfFameLastUpdated, setHallOfFameLastUpdated] = useState(null);
  const [hasLoadedHallOfFame, setHasLoadedHallOfFame] = useState(false);

  // [추가] 초기화 상태 추적
  const [isInitialized, setIsInitialized] = useState(false);

  // [🔧 수정] 명예의 전당 데이터 로드 함수 - 게스트도 허용
  const loadHallOfFameData = useCallback(async () => {
    // [수정] 게스트도 명예의 전당 볼 수 있도록 허용
    // if (!piUser || ... ) { ... } // 체크 제거

    console.log('[DonationContext] loadHallOfFameData 호출됨 - 사용자:', piUser ? piUser.username : 'Guest');

    // 이미 로드했거나 로딩 중이면 스킵
    if (hasLoadedHallOfFame || isHallOfFameLoading) {
      console.log('[DonationContext] 명예의 전당 데이터 이미 로드됨 또는 로딩 중');
      return;
    }

    console.log('[DonationContext] 🎯 비용 최적화: 백엔드 API 호출 시작');
    setIsHallOfFameLoading(true);
    setHallOfFameError(null);

    try {
      // [비용 최적화] Firestore 직접 읽기 시도 (실패 시 API 폴백)
      const firestoreService = (await import('../services/firestoreService')).default;
      const { getDonationHallOfFame: getDonationHallOfFameAPI } = await import('../services/api');
      const environment = window.__APP_ENVIRONMENT__ || 'development';

      const data = await firestoreService.getDonationHallOfFame(
        environment,
        () => getDonationHallOfFameAPI(environment) // 폴백 함수
      );

      console.log('[DonationContext] ✅ 명예의 전당 데이터 로드 성공:', data.length, '명');

      setHallOfFameData(data);
      setHallOfFameLastUpdated(new Date());
      setHasLoadedHallOfFame(true);

    } catch (error) {
      console.error('[DonationContext] 명예의 전당 데이터 로드 실패:', error);
      setHallOfFameError(error.message);

      // [안전장치] 에러 발생 시 빈 배열로 설정하여 앱이 중단되지 않도록 함
      setHallOfFameData([]);
      // [수정] 에러 시에는 loaded 상태를 true로 설정하지 않음 -> 다음에 재시도 허용
    } finally {
      setIsHallOfFameLoading(false);
    }
  }, [hasLoadedHallOfFame, isHallOfFameLoading]);

  // [추가] 초기화 useEffect
  useEffect(() => {
    setIsInitialized(true);
    console.log('[DonationContext] DonationProvider 초기화 완료, piUser:', piUser);
  }, [piUser]);

  // [🔧 최적화] 자동 로딩 제거 - HallOfFame 컴포넌트 마운트 시 호출로 변경
  // useEffect 제거됨

  const value = {
    // 상태
    hallOfFameData,
    isHallOfFameLoading,
    hallOfFameError,
    hallOfFameLastUpdated,

    // 함수
    loadHallOfFameData
  };

  return (
    <DonationContext.Provider value={value}>
      {children}
    </DonationContext.Provider>
  );
};